import * as React from 'react';

import { getDisplayName } from './getDisplayName';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function wrapDisplayName(Component: React.ComponentType<React.PropsWithChildren<any>>, hocName: string): string {
  return `${hocName}(${getDisplayName(Component)})`;
}
